import { render, staticRenderFns } from "./ScheduleOnboardingBar.vue?vue&type=template&id=08a0ba28&"
import script from "./ScheduleOnboardingBar.vue?vue&type=script&lang=ts&"
export * from "./ScheduleOnboardingBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports